import {LEAGUES} from '../constants/leagues';

/**
 * ОЧКИ КОЛЛЕКЦИИ.
 *
 * Очки показывают, насколько ценна коллекция игрока: открытые фракции,
 * обличия фракций, обличия отрядов и рейтинговые образы. Они стоят в профиле
 * рядом с рейтингом, по ним строится раздел «Лучшие коллекции». Сам расчет —
 * в utils/collection/calculateCollectionPoints.
 *
 * Шкала очков — нумены: покупное обличие дает столько очков, сколько нуменов
 * за него просят. Числа ниже приводят к этой же шкале все, что за нумены не
 * продается.
 *
 * Конфиг общий для клиента и сервера: сервер считает и хранит очки
 * (User.collectionPoints), и клиент не должен разойтись с ним в числах.
 */

/**
 * Очки за открытую фракцию. Фракция приравнена к самому дорогому обличию за
 * нумены («Орден грифона», 200 000): она не должна цениться ниже, чем обличие
 * к ней. Число утверждено как фиксированное и за максимумом цен само не
 * следует — что обличий дороже нет, сторожит тест.
 */
export const COLLECTION_POINTS_PER_FACTION = 200000;

/**
 * Очки за один кристалл цены — для обличий, которые продаются за кристаллы
 * (бывшие рубиновые образы, 200–500 кристаллов). С таким курсом они встают в
 * один ряд с дорогими обличиями за нумены.
 */
export const COLLECTION_POINTS_PER_CRYSTAL = 300;

/**
 * Очки за рейтинговый образ фракции — по его лиге. Эти образы не купить: их
 * выдают за победы в рейтинговых матчах, поэтому они самые ценные в
 * коллекции — даже золотой дороже любого покупного обличия.
 */
export const COLLECTION_POINTS_BY_RANK_SKIN_LEAGUE = {
  [LEAGUES.GOLD]: 300000,
  [LEAGUES.DIAMOND]: 1000000,
  [LEAGUES.RUBY]: 3000000,
};
